module.exports = __webpack_public_path__ + "img/w3.ab6cb090.png";